import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import type { UserList } from 'types/api'
import { BaseParams, BaseResponse } from 'types/utils'

export const clientsQueryKey = ['clients']

export function useClients({
  params
}: BaseParams<{
  search?: string
  ordering?: string
  limit?: number
  offset?: string
  roles?: UserList['role']
  exclude_role?: UserList['role']
  date_joined_from?: string
  date_joined_to?: string
  nationality?: string
  is_partner?: boolean
  was_contacted?: boolean
  has_ongoing_offer?: boolean
}> = {}) {
  const [searchParams] = useSearchParams()
  const search = params?.search || searchParams.get('search')
  const ordering = params?.ordering || searchParams.get('ordering')
  const limit = params?.limit || searchParams.get('limit')
  const offset = params?.offset || searchParams.get('offset')
  const roles = params?.roles || searchParams.get('roles')
  const date_joined_from =
    params?.date_joined_from || searchParams.get('date_joined_from')
  const date_joined_to =
    params?.date_joined_to || searchParams.get('date_joined_to')
  const nationality = params?.nationality || searchParams.get('nationality')
  const is_partner = searchParams.get('is_partner') || undefined
  const was_contacted = searchParams.get('was_contacted') || undefined
  const has_ongoing_offer = params?.has_ongoing_offer

  async function getClients() {
    const response = await apiClient.get<BaseResponse<UserList>>(
      `${SNA_PREFIX}users`,
      {
        params: {
          roles,
          exclude_role: params?.exclude_role,
          search,
          ordering,
          limit,
          offset,
          date_joined_from,
          date_joined_to,
          nationality,
          is_partner,
          was_contacted,
          has_ongoing_offer
        }
      }
    )
    return response.data
  }

  return useQuery({
    queryFn: getClients,
    queryKey: [
      ...clientsQueryKey,
      search,
      ordering,
      limit,
      offset,
      roles,
      params?.exclude_role,
      date_joined_from,
      date_joined_to,
      nationality,
      is_partner,
      was_contacted,
      has_ongoing_offer
    ]
  })
}
